import { cn } from "@/lib/utils";

/**
 * Rechtlich vorgeschriebener Disclaimer-Text - wortgleich ueberall im Produkt
 * (Footer, Aktienseite unter dem Score, spaeter Depot-Check-Ausgabe/E-Mails).
 * Nicht umformulieren, ohne den rechtlichen Wortlaut zu pruefen.
 *
 * Prominenz bewusst konservativ erhoeht (backlog.md -> Feedback-Runde 19 Punkt 2,
 * 2026-07-28): nur `font-medium` ergaenzt (keine Farb-/Groessenaenderung, kein
 * Layout-Risiko) - haelt sich an der einzigen bestehenden Stelle, an der der
 * Disclaimer schon rendert, statt neue Platzierungen hinzuzufuegen. Erik wollte
 * einen dominanteren Disclaimer, die genaue Reichweite (nur hier vs. zusaetzliche
 * Stellen/staerkerer Kontrast) war aber als klaerungsbeduerftig markiert - falls das
 * nicht reicht, naechster Schritt waere Ruecksprache statt weiterer eigenstaendiger
 * Eskalation.
 */
export function Disclaimer({ className }: { className?: string }) {
  return (
    <p className={cn("text-xs font-medium text-muted-foreground", className)}>
      Erikonomie stellt ausschließlich allgemeine, automatisiert berechnete Informationen
      zu öffentlich verfügbaren Finanzkennzahlen bereit. Dies ist keine Anlageberatung,
      keine Anlagevermittlung und keine Kauf- oder Verkaufsempfehlung. Alle Angaben ohne
      Gewähr. Investitionsentscheidungen triffst du eigenverantwortlich.
    </p>
  );
}
